(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["roi-product-information"] && !Shopify.designMode) return;
  try {
    (() => {
    const japanHour = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Tokyo',
      hour: '2-digit',
      hourCycle: 'h23'
    });
    const japanDate = new Intl.DateTimeFormat('ja-JP', {
      timeZone: 'Asia/Tokyo',
      month: 'numeric',
      day: 'numeric'
    });
    let timer;

    function updateShippingTime() {
      const now = new Date();
      const parts = japanHour.formatToParts(now);
      const hour = Number(parts.find((part) => part.type === 'hour').value);
      const tomorrowParts = japanDate.formatToParts(new Date(now.getTime() + 86400000));
      const month = Number(tomorrowParts.find((part) => part.type === 'month').value);
      const day = Number(tomorrowParts.find((part) => part.type === 'day').value);
      const message = hour < 15
        ? '15:00までのご注文で当日発送'
        : `明日${month}月${day}日発送`;
      document.querySelectorAll('[data-roi-shipping-time]').forEach((element) => {
        if (element.textContent !== message) element.textContent = message;
        element.classList.toggle('is-same-day', hour < 15);
      });
    }

    function scheduleShippingTime() {
      clearTimeout(timer);
      updateShippingTime();
      timer = setTimeout(scheduleShippingTime, 60000 - (Date.now() % 60000) + 25);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleShippingTime, { once: true });
    } else {
      scheduleShippingTime();
    }
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') scheduleShippingTime();
    });
    window.addEventListener('pageshow', scheduleShippingTime);
    document.addEventListener('shopify:section:load', updateShippingTime);
  })();
  } catch(e) { console.error(e); }
})();

})();
